import { FormikProps } from 'formik/dist/types';
import * as Yup from 'yup';
import { ErrorWord, AccountEstablishRequestParam, EstablishPageType } from '../common';

/*--------------
  証券同意
  --------------*/

//入力値の型
export type ConsentSecuritiesType = {
  // 証券取引約款についての同意
  securitiesTradingTermsAgreement: boolean;
  // 証券取引約款についての同意を読んだか。リクエストに不要
  isReadSecuritiesTradingTermsAgreement: boolean;
  // 契約締結前交付書面についての同意
  preContractAgreement: boolean;
  // 契約締結前交付書面についての同意を読んだか。リクエストに不要
  isReadPreContractAgreement: boolean;
  // 情報共有についての同意
  informationSharingAgreement: boolean;
  // 情報共有についての同意を読んだか。リクエストに不要
  isReadInformationSharingAgreement: boolean;
  // 反社会的勢力ではないことの同意
  antiSocialForcesCheckAgreement: boolean;
  // 反社会的勢力ではないことの同意を読んだか。リクエストに不要
  isReadAntiSocialForcesCheckAgreement: boolean;
};
//Formik用の型
export type ConsentSecuritiesFormikType = FormikProps<ConsentSecuritiesType>;

//Formikに渡す初期値
export const consentSecuritiesInitialValues = (param: ConsentSecuritiesType) => {
  return {
    ...param,
    securitiesTradingTermsAgreement: param.securitiesTradingTermsAgreement ?? false,
    isReadSecuritiesTradingTermsAgreement: param.isReadSecuritiesTradingTermsAgreement ?? false,
    preContractAgreement: param.preContractAgreement ?? false,
    isReadPreContractAgreement: param.isReadPreContractAgreement ?? false,
    informationSharingAgreement: param.informationSharingAgreement ?? false,
    isReadInformationSharingAgreement: param.isReadInformationSharingAgreement ?? false,
    antiSocialForcesCheckAgreement: param.antiSocialForcesCheckAgreement ?? false,
    isReadAntiSocialForcesCheckAgreement: param.isReadAntiSocialForcesCheckAgreement ?? false,
  };
};

//バリデーション
export const consentSecuritiesValidation = Yup.object().shape({
  securitiesTradingTermsAgreement: Yup.bool().oneOf([true], ErrorWord.UABLE_OPEN_ACCOUNT),
  isReadSecuritiesTradingTermsAgreement: Yup.bool().oneOf(
    [true],
    '証券取引約款についてのリンクから内容をご確認ください',
  ),
  preContractAgreement: Yup.bool().oneOf([true], ErrorWord.UABLE_OPEN_ACCOUNT_TYPE4),
  isReadPreContractAgreement: Yup.bool().oneOf([true], '契約締結前交付書面についてのリンクから内容をご確認ください'),
  informationSharingAgreement: Yup.bool().oneOf([true], ErrorWord.UABLE_OPEN_ACCOUNT),
  isReadInformationSharingAgreement: Yup.bool().oneOf([true], '情報共有同意書についてのリンクから内容をご確認ください'),
  antiSocialForcesCheckAgreement: Yup.bool().oneOf([true], ErrorWord.UABLE_OPEN_ACCOUNT),
  isReadAntiSocialForcesCheckAgreement: Yup.bool().oneOf(
    [true],
    '反社会的勢力ではないことの表明・確約に関する同意についてのリンクから内容をご確認ください',
  ),
});

//Formikのサブミットメソッド
export const consentSecuritiesOnSubmit = (
  param: AccountEstablishRequestParam,
  setNowEstablishPageType: (navType: EstablishPageType) => void,
  add: (data: AccountEstablishRequestParam) => void,
) => {
  return (values: ConsentSecuritiesType) => {
    add({
      ...param,
      securitiesTradingTermsAgreement: values.securitiesTradingTermsAgreement,
      isReadSecuritiesTradingTermsAgreement: values.isReadSecuritiesTradingTermsAgreement,
      preContractAgreement: values.preContractAgreement,
      isReadPreContractAgreement: values.isReadPreContractAgreement,
      informationSharingAgreement: values.informationSharingAgreement,
      isReadInformationSharingAgreement: values.isReadInformationSharingAgreement,
      antiSocialForcesCheckAgreement: values.antiSocialForcesCheckAgreement,
      isReadAntiSocialForcesCheckAgreement: values.isReadAntiSocialForcesCheckAgreement,
    });
    setNowEstablishPageType(EstablishPageType.ConsentTrust);
  };
};
